<template>
    <div class="login-index">
        <div style="margin: auto">

            <v-btn id="bbb" @click="openNewWindos"></v-btn>

        </div>
    </div>


</template>

<script>

    export default {

        data() {
           return{
            }
        },
        created() {

        },
        mounted() {
             document.querySelector("#bbb").click()


        },
        methods:{
            openNewWindos(){

                if(this.$route.query.wtrealm && this.$route.query.wresult){

                    // //owa
                    let url =this.$route.query.wtrealm
                    let samlResponse =  decodeURIComponent(this.$route.query.wresult)

                    let formStr = "<form style=\"visibility:hidden;\" method=\"POST\" action='" + url + "'>" +
                        '<input type="hidden" name="wa" value="wsignin1.0" />' +
                        "<input type=\"hidden\" name=\"wresult\" value='" +samlResponse+ "' />" +
                        '</form>';
                    let win = window.open("", "_blank",'width=200,height=100,status=no,alwaysLowered=yes,');
                    win.document.body.innerHTML = formStr;
                    win.document.forms[0].submit();
                    setTimeout(()=>{
                         win.close()
                        window.location.href = url
                        // var formStr = "<form style=\"visibility:hidden;\" method=\"POST\" action='" + url + "'>" +
                        //     '<input type="hidden" name="wa" value="wsignin1.0" />' +
                        //     "<input type=\"hidden\" name=\"wresult\" value='" +samlResponse+ "' />" +
                        //     '</form>';
                        // var wins = window.open("", "_self",);
                        // wins.document.body.innerHTML = formStr;
                        // wins.document.forms[0].submit();
                    },3000)

                }else{
                    window.location.href="/"
                }



            }


        }


    }
    </script>

<style lang='scss' scoped>
    .login-index {


        // background: linear-gradient(143deg, #2E6BF7, #2EB7F7);
        display: flex;
        position: relative;

    }
</style>
